export type IconeGrupo =
  | 'agenda' | 'atendimento' | 'producao' | 'financeiro' | 'notas' | 'comercial' | 'administrativo' | 'outros' | 'documento';

export const ICONE_PADRAO: IconeGrupo = 'documento';

// Grupos da Agenda (ORDEM_GRUPOS + "Outros" do app.js), comparados sem acento e sem caixa.
const ICONES: Record<string, IconeGrupo> = {
  'agenda': 'agenda',
  'atendimento': 'atendimento',
  'producao medica': 'producao',
  'financeiro': 'financeiro',
  'notas fiscais': 'notas',
  'comercial': 'comercial',
  'administrativo': 'administrativo',
  'outros': 'outros',
};

export function iconeDoGrupo(grupo: string | null | undefined): IconeGrupo {
  const chave = (grupo ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
  return ICONES[chave] ?? ICONE_PADRAO;
}
